<template>
  <div
    class="relative items-center bg-white dark:bg-slate-900 min-w-0 contact-info-modal"
    :class="{
      'contact-info-modal--contacts-modal': isModalView,
      'contact-info-modal--embedded-panel': !isModalView,
    }"
  >
    <div
      v-if="showContactDetailsLoadingOverlay && !isModalView"
      class="contact-info-modal__loading-overlay"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div class="contact-info-modal__loading-spinner" aria-hidden="true" />
      <p class="contact-info-modal__loading-text">
        {{ $t('CONTACT_PROFILE.LOADING') }}
      </p>
    </div>
    <div class="text-left rtl:text-right w-full h-full">
      <div class="flex items-center w-full contact-modal-header">
        <h3
          class="text-base text-slate-800 dark:text-slate-100 capitalize text-more contact-modal-title"
          :class="dynamicClasses"
        >
          {{ $t('CONTACT_PANEL.MORE_DETAILS') }}
        </h3>
        <div
          class="flex items-center gap-1.5 ml-auto contact-modal-header__actions"
        >
          <woot-button
            v-tooltip="$t('CONTACT_PANEL.COPY_PROFILE_LINK')"
            :title="$t('CONTACT_PANEL.COPY_PROFILE_LINK')"
            :icon="profileLinkCopied ? 'checkmark' : 'copy'"
            size="small"
            variant="clear"
            color-scheme="secondary"
            :is-blue="!profileLinkCopied"
            :class-names="
              profileLinkCopied
                ? 'copy-profile-link-button-class copy-profile-link-button-class--copied'
                : 'copy-profile-link-button-class'
            "
            @click="copyContactProfileLink"
          />
          <CallViaDropdown
            class="contact-modal-call-dropdown"
            :domestic-inboxes="domesticInboxes"
            :show-international-call="showCallButton"
            :is-busy="isCreatingCall"
            icon-only
            menu-opens-below
            menu-align-end
            @domestic-call="initializeDomesticCall"
            @international-call="startupClient"
          />
          <woot-button
            v-tooltip="$t('EDIT_CONTACT.BUTTON_LABEL')"
            title="$t('EDIT_CONTACT.BUTTON_LABEL')"
            icon="edit-contact"
            size="small"
            :class-names="'edit-button-class'"
            @click="toggleEditModal"
          />
          <a
            v-if="showOpenContactProfileButton"
            :href="contactProfileLink"
            class="fs-default contact-modal-header__link"
            target="_blank"
            rel="noopener nofollow noreferrer"
          >
            <woot-button
              icon="fullscreen"
              view-box="-4 -4 24 24"
              size="small"
              variant="clear"
              color-scheme="secondary"
              :class-names="'contact-modal-header-icon-button'"
              :class="dynamicClasses"
            />
          </a>
          <woot-button
            v-if="showCloseButton"
            :icon="closeIconName"
            size="small"
            variant="clear"
            color-scheme="secondary"
            :class-names="
              'contact-modal-header-icon-button contact-modal-header-icon-button--close'
            "
            :class="dynamicClasses"
            @click="closePanel"
          />
        </div>
      </div>
      <!-- <div class="relative-position">
        <div class="relative">
          <woot-button
            v-tooltip="$t('EDIT_CONTACT.BUTTON_LABEL')"
            title="$t('EDIT_CONTACT.BUTTON_LABEL')"
            icon="edit"
            variant="smooth"
            size="small"
            @click="toggleEditModal"
            class="custom-button"
            :class="dynamicClasses"
          />

          <woot-button
            icon="more-vertical"
            v-tooltip="$t('EDIT_CONTACT.MORE_DETAILS')"
            class="custom-button more-vertical-icon clear secondary rtl:rotate-180"
            :class="dynamicClasses"
            @click="toggleOptionsVisibility"
          />

          <div
            v-if="showOptions"
            class="flex items-center gap-2 options-container"
            v-on-clickaway="closeOptions"
          >
            <woot-button
              v-tooltip="$t('CONTACT_PANEL.NEW_MESSAGE')"
              title="$t('CONTACT_PANEL.NEW_MESSAGE')"
              icon="chat-messenger"
              :viewBox="'0 0 24 24'"
              size="small"
              @click.stop="handleChatMessengerClick"
            />

            <woot-button
              v-tooltip="$t('CONTACT_PANEL.MERGE_CONTACT')"
              title="$t('CONTACT_PANEL.MERGE_CONTACT')"
              icon="merge"
              variant="smooth"
              size="small"
              color-scheme="secondary"
              :disabled="uiFlags.isMerging"
              @click.stop="handleMergeClick"
            />
            <woot-button
              v-if="isAdmin"
              v-tooltip="$t('DELETE_CONTACT.BUTTON_LABEL')"
              title="$t('DELETE_CONTACT.BUTTON_LABEL')"
              icon="delete"
              variant="smooth"
              size="small"
              color-scheme="alert"
              :disabled="uiFlags.isDeleting"
              @click.stop="handleDeleteClick"
            />

            <woot-button
              v-if="isConversationPage"
              v-tooltip="$t('EDIT_CONTACT.SET_REMAINDER')"
              title="$t('EDIT_CONTACT.SET_REMAINDER')"
              icon="calendar-clock"
              color-scheme="secondary"
              size="small"
               @click.stop="handleRemainderClick"
            />
            <woot-button
               v-if="isContactPage"
              v-tooltip="$t('ADD_AGENT.BUTTON_LABEL')"
              :title="$t('ADD_AGENT.TITLE')"
              :icon="userIcon"
              color-scheme="secondary"
              variant="smooth"
              size="small"
              @click.stop="handletoggleDropdown"
            />

            <draggable-file
              :show="showDragmodal"
              :formatted="formattedTime"
              :hangup="CallHangup"
              :selectedContact="selectedContact"
            />
          </div>
        </div>
      </div> -->
      <!-- <div class="flex justify-center">
        <thumbnail
          v-if="showAvatar"
          :src="contact.thumbnail"
          size="90px"
          :username="contact.name"
          :status="contact.availability_status"
        />
      </div> -->

      <div class="mt-2 w-full">
        <!-- <div class="flex gap-1 items-center justify-center mb-2">
          
        
        </div>
        <div
          v-if="showAvatar"
          class="flex items-center mb-2 gap-1 justify-between"
        >
          <div class="flex gap-1">
            <fluent-icon
              v-if="contact.created_at"
              v-tooltip.right="
                `${$t('CONTACT_PANEL.CREATED_AT_LABEL')} ${dynamicTime(
                  contact.created_at
                )}`
              "
              icon="info"
              size="20"
              class="blue-color has-tooltip mt-0.5 position-relative"
            />
            <h3
              class="text-base text-slate-800 dark:text-slate-100 capitalize whitespace-normal my-0 lightgrey pl-2 cursor-pointer"
                :title="contact.name.length > 15 ? contact.name : ''"
            >
              {{ contact.name.length>15? contact.name.slice(0,15)+'...':contact.name }}
            </h3>
          </div>
          <div v-if="!this.isSpecialRoute">
            <a
              :href="contactProfileLink"
              class="fs-default"
              target="_blank"
              rel="noopener nofollow noreferrer"
            >
              <woot-button
                size="tiny"
                icon="open"
                variant="clear"
                color-scheme="secondary"
              />
            </a>
          </div>
        </div> -->

        <!-- <p
          v-if="additionalAttributes.description"
          class="break-words lightgrey relative group"
          
        >
        Bio: 
    {{ additionalAttributes.description.length > 50 
        ? additionalAttributes.description.slice(0, 50) + "..." 
        : additionalAttributes.description }}

        <span
         v-if="additionalAttributes.description.length > 50"
         class="hidden group-hover:block absolute top-6 left-0 bg-white dark:bg-gray-800 text-black dark:text-black p-2 shadow-md  max-w-sm z-10 border border-gray-300 dark:border-gray-600 "
         style="white-space: normal; word-break: break-word;"
       >
      {{ additionalAttributes.description }}
    </span>
        </p> -->
        <div
          class="flex justify-between items-start mb-6 bg-slate-25 rounded-md dark:bg-slate-900 contact-profile-card"
        >
          <div class="flex gap-3">
            <div class="mr-4">
              <thumbnail
                v-if="showAvatar"
                :src="contact.thumbnail"
                size="90px"
                :username="contact.name"
                :status="contact.availability_status"
              />
            </div>
            <div>
              <div class="flex items-center flex-wrap gap-1">
                <lead-quality-crown
                  v-if="contact.id && accountId"
                  :account-id="accountId"
                  :metadata="
                    contact.lead_quality_metadata || latestLeadQualityMetadata
                  "
                  :allow-muted-crown-below-threshold="true"
                  :opens-result-modal="isLeadQualityEnabled"
                  :tooltip-cta-only="true"
                  @open-lead-quality-result="onOpenLeadQualityFromCrown"
                />
                <h2
                  class="text-xl font-semibold text-slate-800 dark:text-slate-100 break-all"
                >
                  {{ contact.name }}
                </h2>
                <contact-summary-button
                  v-if="contact.id && accountId && isContactSummaryEnabled"
                  :account-id="accountId"
                  :contact-id="contact.id"
                  :has-existing-summary="hasContactSummary"
                  class="contact-summary-icon-cell flex-shrink-0"
                  @summary="onContactSummary"
                  @error="onContactSummaryError"
                />
                <lead-quality-button
                  v-if="contact.id && accountId && isLeadQualityEnabled"
                  ref="leadQualityButtonRef"
                  :account-id="accountId"
                  :contact-id="contact.id"
                  class="flex-shrink-0"
                  @quality="onLeadQuality"
                  @error="onLeadQualityError"
                />
                <lead-response-watch
                  class="flex-shrink-0 self-center"
                  :waiting-since-unix="contactResponseWatchData.unix"
                  :force-red="contactResponseWatchData.forceRed"
                />
                <span class="text-gray-500">{{
                  additionalAttributes.team
                }}</span>
              </div>
              <p
                v-if="
                  contact.id &&
                    isContactSummaryEnabled &&
                    showContactSummaryTimestamp
                "
                class="text-gray-500 dark:text-gray-500 text-xs contact-summary-generated-at mb-0"
              >
                {{ $t('CONTACT_SUMMARY.LAST_GENERATED') }}:
                {{ contactSummaryGeneratedAt }}
              </p>
              <p
                v-if="leadQualityError"
                class="text-sm text-red-600 dark:text-red-400 mt-1 mb-0"
              >
                {{ leadQualityError }}
              </p>
              <div
                v-if="contactSummaryText || contactSummaryError"
                class="contact-summary-block mt-2 mb-0"
              >
                <p
                  v-if="contactSummaryText"
                  class="text-gray-600 dark:text-gray-400 text-sm contact-summary-line"
                >
                  {{ contactSummaryText }}
                </p>
                <p
                  v-if="contactSummaryError"
                  class="text-sm contact-summary-error-line"
                >
                  {{ contactSummaryError }}
                </p>
              </div>
              <div class="w-full overflow-hidden">
                <p
                  class="text-gray-600 dark:text-gray-400 mt-1 break-all overflow-hidden text-sm"
                >
                  {{ additionalAttributes.description }}
                </p>
              </div>
              <!-- Add labels section -->
              <div class="flex mt-2 gap-2">
                <contact-label
                  :contact-id="contact.id"
                  class="contact-labels"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-4 mb-6 contact-details-grid"
        >
          <!-- Email -->
          <div class="min-w-0 flex items-start gap-2">
            <div
              v-tooltip="'Email'"
              class="icon-text flex-shrink-0 p-1 rounded dark:bg-transparent mt-1"
            >
              <fluent-icon icon="mail" size="10" />
            </div>
            <div class="min-w-0 flex-1 flex items-center gap-1 flex-nowrap">
              <p
                v-tooltip="
                  contact?.email && contact.email.length > 20
                    ? contact.email
                    : ''
                "
                class="contact-info-text-ellipsis text-slate-400 dark:text-gray-300 mb-0 min-w-0"
              >
                {{ contact.email || 'Not Available' }}
              </p>
              <woot-button
                v-if="contact.email"
                v-tooltip.top="'Copy email'"
                variant="clear"
                size="tiny"
                color-scheme="secondary"
                icon="copy"
                class="flex-shrink-0 self-center"
                @click="copyToClipboard(contact.email, 'Email')"
              />
            </div>
          </div>

          <!-- Phone -->
          <div class="min-w-0 flex items-start gap-2">
            <div
              v-tooltip="'Contact No'"
              class="icon-text flex-shrink-0 p-1 rounded mt-1"
            >
              <fluent-icon icon="call" size="10" />
            </div>
            <div class="min-w-0 flex-1 flex items-center gap-1 flex-nowrap">
              <p
                v-tooltip="
                  contact?.phone_number && contact.phone_number.length > 20
                    ? contact.phone_number
                    : ''
                "
                class="contact-info-text-ellipsis text-slate-400 dark:text-gray-300 mb-0 min-w-0"
              >
                {{ contact.phone_number || 'Not Available' }}
              </p>
              <woot-button
                v-if="contact.phone_number"
                v-tooltip.top="'Copy phone number'"
                variant="clear"
                size="tiny"
                color-scheme="secondary"
                icon="copy"
                class="flex-shrink-0 self-center"
                @click="copyToClipboard(contact.phone_number, 'Phone number')"
              />
            </div>
          </div>

          <!-- Location -->
          <div class="min-w-0 flex items-start gap-2">
            <div
              v-tooltip="'Location'"
              class="icon-text flex-shrink-0 mr-1 p-1 rounded mt-1"
            >
              <fluent-icon icon="map" size="10" />
            </div>
            <div class="min-w-0 flex-1">
              <p
                v-tooltip="location && location.length > 20 ? location : ''"
                class="contact-info-text-ellipsis text-slate-400 dark:text-gray-300 mb-0 min-w-0"
              >
                {{ location || 'Not Available' }}
              </p>
            </div>
          </div>

          <!-- Meeting time -->
          <div class="min-w-0 flex items-start gap-2">
            <div
              v-tooltip="'Set Remainder'"
              class="icon-text flex-shrink-0 rounded mt-1"
            >
              <fluent-icon
                icon="clock"
                size="20"
                class="translate-x-[19%] translate-y-[18%]"
              />
            </div>
            <div class="min-w-0 flex-1 flex items-start gap-1">
              <p
                v-tooltip="
                  this.setReminder && this.setReminder.length > 20
                    ? this.setReminder
                    : ''
                "
                class="contact-info-text-ellipsis text-slate-400 dark:text-gray-300 mb-0 min-w-0"
              >
                {{ this.setReminder || 'Not Available' }}
              </p>
              <woot-button
                v-tooltip="
                  hasCalendarReminder(contact)
                    ? 'Edit Reminder'
                    : 'Add Reminder'
                "
                :icon="hasCalendarReminder(contact) ? 'edit-contact' : 'add'"
                size="tiny"
                variant="clear"
                color-scheme="secondary"
                class="flex-shrink-0"
                @click="openRemainderModal"
              />
            </div>
          </div>
          <div class="min-w-0 flex items-start gap-2">
            <div
              v-tooltip="$t('EDIT_CONTACT.DEMO_MEETING')"
              class="icon-text flex-shrink-0 p-1 rounded mt-1"
            >
              <fluent-icon icon="video" size="10" />
            </div>
            <div class="min-w-0 flex-1 flex items-start gap-1">
              <p
                v-tooltip="
                  formattedDemoTiming && formattedDemoTiming.length > 20
                    ? formattedDemoTiming
                    : ''
                "
                class="contact-info-text-ellipsis text-slate-400 dark:text-gray-300 mb-0 min-w-0"
              >
                {{ formattedDemoTiming || 'Not Available' }}
              </p>
              <woot-button
                v-if="hasDemoMeetingLink"
                v-tooltip="$t('EDIT_CONTACT.COPY_MEETING_LINK')"
                icon="copy"
                size="tiny"
                variant="clear"
                color-scheme="secondary"
                class="flex-shrink-0"
                @click="copyMeetingLink"
              />
              <woot-button
                v-if="canBookMeeting"
                v-tooltip="$t('EDIT_CONTACT.BOOK_MEETING')"
                icon="add"
                size="tiny"
                variant="clear"
                color-scheme="secondary"
                class="flex-shrink-0"
                @click="openBookMeetingModal"
              />
              <woot-button
                v-if="canRescheduleMeeting"
                v-tooltip="$t('EDIT_CONTACT.RESCHEDULE_MEETING')"
                icon="edit-contact"
                size="tiny"
                variant="clear"
                color-scheme="secondary"
                class="flex-shrink-0"
                @click="openRescheduleMeetingModal"
              />
              <woot-button
                v-if="canCancelMeeting"
                v-tooltip="$t('EDIT_CONTACT.CANCEL_MEETING')"
                icon="delete"
                size="tiny"
                variant="clear"
                color-scheme="secondary"
                class="flex-shrink-0"
                @click="confirmCancelMeeting"
              />
            </div>
          </div>

          <!-- Company (below reminder) -->
          <div class="min-w-0 flex items-start gap-2 sm:col-span-2">
            <div
              v-tooltip="'Company'"
              class="icon-text flex-shrink-0 p-1 rounded mt-1"
            >
              <fluent-icon icon="building-bank" size="10" />
            </div>
            <div
              class="min-w-0 flex-1 flex items-start gap-1 overflow-hidden max-w-[14rem]"
            >
              <p
                v-tooltip="companyNameTooltip"
                class="contact-info-text-ellipsis text-slate-400 dark:text-gray-300 mb-0 min-w-0"
              >
                {{ additionalAttributes.company_name || 'Not Available' }}
              </p>
              <woot-button
                v-tooltip="$t('EDIT_CONTACT.EDIT_COMPANY_NAME')"
                icon="edit-contact"
                size="tiny"
                variant="clear"
                color-scheme="secondary"
                class="flex-shrink-0"
                @click="toggleEditModal"
              />
            </div>
          </div>
        </div>
        <div class="flex flex-nowrap gap-4 mb-4 contact-board-selectors">
          <!-- Boards Dropdown -->
          <!-- <div>
            <label>Select Boards</label>
            <select v-model="selectedBoard" @change="handleChange" class="border px-2 py-1">
              <option disabled value="">Select a Board</option>
              <option v-for="board in boards" :key="board.id" :value="board.id">
                {{ board.name }}
              </option>
            </select>
          </div> -->
          <!-- <div style="width: 300px;">
          <label>Select Boards</label>
            <multiselect
              v-model="selectedBoard"
              :options="boards"
              track-by="id"
              label="name"
              select-label="Select"
              deselect-label=""
              placeholder="Select a Board"
              :allow-empty="false"
              :option-disabled="isOptionDisabled"
              @input="handleChange"
            />
        </div> -->

          <div class="board-selector-wrapper">
            <div class="board-selector">
              <label>Select Boards</label>
              <woot-button
                variant="smooth"
                size="small"
                color-scheme="primary"
                class="board-button"
                @click="toggleBoardModal"
              >
                <span class="board-button__inner">
                  <span class="board-button__text">
                    {{ selectedBoard ? selectedBoard.name : 'Select a Board' }}
                  </span>
                  <fluent-icon
                    :icon="showBoardModal ? 'chevron-up' : 'chevron-down'"
                    size="16"
                    class="board-button__chevron"
                  />
                </span>
              </woot-button>
            </div>
            <transition name="fade">
              <board-selection-modal
                v-if="showBoardModal"
                :boards="boards"
                :selected-board="selectedBoard"
                @close="toggleBoardModal"
                @select="handleBoardSelection"
                @remove="handleBoardRemove"
              />
            </transition>
          </div>

          <!-- States Dropdown (Populated after Board selection) -->
          <!-- <div>
            <label>Select Pipeline</label>
            <select v-model="selectedState" @change="moveItem"  class="border px-2 py-1" :disabled="!stateList.length">
              <option disabled value="">Select a Status</option>
              <option v-for="state in stateList" :key="state.id" :value="state.id">
                {{ state.name }}
              </option>
            </select>
          </div> -->
          <!-- <div style="width: 300px;">
          <label>Select Pipeline</label>
            <multiselect
              v-model="selectedState"
              :options="stateList"
              track-by="id"
              label="name"
              select-label="Select"
              deselect-label=""
              placeholder="Select a Status"
              :allow-empty="false"
              @input="moveItem"
            />
        </div> -->

          <div class="board-selector-wrapper">
            <div class="board-selector">
              <label>Select Pipeline</label>
              <woot-button
                variant="smooth"
                size="small"
                color-scheme="primary"
                class="board-button"
                @click="toggleStatusModal"
              >
                <span class="board-button__inner">
                  <span class="board-button__text">
                    {{
                      selectedStatus ? selectedStatus.name : 'Select a Status'
                    }}
                  </span>
                  <fluent-icon
                    :icon="showStatusModal ? 'chevron-up' : 'chevron-down'"
                    size="16"
                    class="board-button__chevron"
                  />
                </span>
              </woot-button>
            </div>
            <transition name="fade">
              <status-selection-modal
                v-if="showStatusModal"
                :states="stateList"
                :selected-status="selectedStatus"
                @close="toggleStatusModal"
                @select="handleStatusSelection"
              />
            </transition>
          </div>

          <div class="board-selector-wrapper">
            <div class="board-selector">
              <label>Select State</label>
              <woot-button
                variant="smooth"
                size="small"
                color-scheme="primary"
                class="board-button"
                @click="toggleStateModal"
              >
                <span class="board-button__inner">
                  <span
                    class="board-button__text board-button__text--with-state"
                  >
                    <span
                      v-if="selectedState && selectedState.color"
                      class="state-color-dot"
                      :style="{ backgroundColor: selectedState.color }"
                    />
                    {{ selectedState ? selectedState.name : 'Select a State' }}
                  </span>
                  <fluent-icon
                    :icon="showStateModal ? 'chevron-up' : 'chevron-down'"
                    size="16"
                    class="board-button__chevron"
                  />
                </span>
              </woot-button>
            </div>
            <transition name="fade">
              <state-selection-modal
                v-if="showStateModal"
                :states="state"
                :selected-state="selectedState"
                @close="toggleStateModal"
                @select="handleStateSelection"
                @remove="handleStateRemove"
              />
            </transition>
          </div>
          <!-- Move Button -->
          <!-- <div class="flex items-center flex-col ">
            <div class="invisible">box</div>
            <button :disabled="!canMove" @click="moveItem"
              class="button label--add smooth h-full tiny primary p-[19px]">
             Move To Boards
            </button>
            <woot-submit-button
              :disabled="isTransfering ? true : !canMove" @click="moveItem"
              :loading="isTransfering"
              :button-text="isTransfering ? 'Moving':'Move To Board'"
              class="move_to_board "
            />
          </div> -->
        </div>
        <div class="flex flex-wrap gap-6 sm:gap-8 contact-links-row">
          <div class="min-w-0 contact-more-links">
            <p
              class="text-xs font-medium text-slate-600 dark:text-slate-400 mb-2 contact-section-label"
            >
              More Links
            </p>
            <div class="flex items-center w-full mt-2 gap-1">
              <woot-button
                v-tooltip="$t('CONTACT_PANEL.NEW_MESSAGE')"
                title="$t('CONTACT_PANEL.NEW_MESSAGE')"
                icon="chat-messenger"
                :is-blue="true"
                size="small"
                :class-names="'contact-modal-links'"
                @click="toggleConversationModal"
              />
              <woot-button
                v-if="isAdmin"
                v-tooltip="$t('ADD_AGENT.BUTTON_LABEL')"
                :title="$t('ADD_AGENT.TITLE')"
                :icon="userIcon"
                :is-blue="true"
                size="small"
                :class-names="{
                  'contact-modal-links': true,
                  'contact-modal-selected': isDropdownVisible,
                }"
                @click="toggleDropdown"
              />
              <!-- <woot-button v-tooltip="$t('EDIT_CONTACT.SET_REMAINDER')" title="$t('EDIT_CONTACT.SET_REMAINDER')"
                icon="calendar-clock" :isBlue="true" size="small" @click="openRemainderModal"
                :classNames="'contact-modal-links'" /> -->
              <woot-button
                v-tooltip="$t('CONTACT_PANEL.MERGE_CONTACT')"
                title="$t('CONTACT_PANEL.MERGE_CONTACT')"
                icon="merge-contact"
                size="small"
                :is-blue="true"
                :view-box="'0 0 15.444 15.444'"
                :disabled="uiFlags.isMerging"
                :class-names="'contact-modal-links'"
                @click="openMergeModal"
              />

              <woot-button
                v-if="isAdmin && hasCalendarReminder(this.contact)"
                v-tooltip="'Mark Reminder as Done'"
                title="Mark follow up"
                icon="clock"
                size="small"
                :is-blue="true"
                :view-box="'0 0 15.444 15.444'"
                :disabled="uiFlags.isMerging"
                :class-names="'contact-modal-links'"
                @click="openRemainderFollowUPModal"
              />

              <woot-button
                v-if="currentChat && currentChat.id"
                v-tooltip="$t('SCHEDULED_DRAFTS.PREVIEW_BUTTON')"
                :title="$t('SCHEDULED_DRAFTS.PREVIEW_BUTTON')"
                icon="mail"
                :is-blue="true"
                size="small"
                :class-names="'contact-modal-links'"
                @click="toggleScheduledDraftsModal"
              />

              <woot-button
                v-if="isAdmin"
                v-tooltip="$t('DELETE_CONTACT.BUTTON_LABEL')"
                title="$t('DELETE_CONTACT.BUTTON_LABEL')"
                icon="delete-contact"
                :view-box="'0 0 10.456 13.444'"
                :is-blue="true"
                size="small"
                :disabled="uiFlags.isDeleting"
                :class-names="'contact-modal-links'"
                @click="toggleDeleteModal"
              />

              <draggable-file
                :show="showDragmodal"
                :formatted="formattedTime"
                :hangup="CallHangup"
                :selected-contact="selectedContact"
              />
            </div>
          </div>
          <div class="min-w-0 contact-social-links">
            <p
              class="text-xs font-medium text-slate-600 dark:text-slate-400 mb-2 contact-section-label"
            >
              Social Links
            </p>
            <div>
              <social-icons
                :social-profiles="socialProfiles"
                custom-class="p-2 bg-slate-25 rounded-md dark:bg-slate-900"
              />
            </div>
          </div>
        </div>
        <!-- <div class="mb-3 lightgrey">
          <contact-info-row
            :href="contact.email ? `mailto:${contact.email}` : ''"
            :value="contact.email"
            icon="mail"
            size="20"
            emoji="✉️"
            :title="$t('CONTACT_PANEL.EMAIL_ADDRESS')"
            show-copy
          />
          <contact-info-row
            :href="contact.phone_number ? `tel:${contact.phone_number}` : ''"
            :value="contact.phone_number"
            icon="call"
            size="20"
            emoji="📞"
            :title="$t('CONTACT_PANEL.PHONE_NUMBER')"
            show-copy
          />
          <contact-info-row
            v-if="contact.identifier"
            :value="contact.identifier"
            icon="contact-identify"
            size="20"
            emoji="🪪"
            :title="$t('CONTACT_PANEL.IDENTIFIER')"
          />
          <contact-info-row
            :value="additionalAttributes.company_name"
            icon="building-bank"
            size="20"
            emoji="🏢"
            :title="$t('CONTACT_PANEL.COMPANY')"
          />
          <contact-info-row
            v-if="location || additionalAttributes.location"
            :value="location || additionalAttributes.location"
            icon="map"
            size="20"
            emoji="🌍"
            :title="$t('CONTACT_PANEL.LOCATION')"
          />
          <contact-info-row
            :value="formattedChatDateTime"
            icon="clock"
            size="20"
            :viewBox="'0 0 15 15'"
            emoji="🏢"
            :title="$t('CONTACT_PANEL.DEMOTIME')"
          />
        </div> -->
      </div>

      <edit-contact
        v-if="showEditModal"
        :show="showEditModal"
        :contact="contact"
        @cancel="toggleEditModal"
      />
      <new-conversation
        v-if="contact.id"
        :show="showConversationModal"
        :contact="contact"
        :open-over-contact-panel="isModalView || isConversationSidebar"
        @cancel="toggleConversationModal"
      />
      <contact-merge-modal
        v-if="showMergeModal"
        :primary-contact="contact"
        :show="showMergeModal"
        @close="toggleMergeModal"
      />
      <set-remainder-modal
        v-if="showRemainderModal"
        :primary-contact="contact"
        :show="showRemainderModal"
        :current-chat="currentChat"
        :date-part="datePart"
        :time-without-z="timeWithoutZ"
        :reminder-flag="reminderFlag"
        @close="toggleReminderModal"
        @success-message="successMessageData"
      />
      <SetRemainderFollowUpModal
        v-if="showRemainderFollowupModal"
        :primary-contact="contact"
        :show="showRemainderFollowupModal"
        :current-chat="currentChat"
        :date-part="datePart"
        :time-without-z="timeWithoutZ"
        :reminder-flag="reminderFlag"
        @close="toggleReminderFollowUpModal"
        @success-message="successMessageData"
      />
    </div>
    <woot-delete-modal
      v-if="showDeleteModal"
      :show.sync="showDeleteModal"
      :on-close="closeDelete"
      :on-confirm="confirmDeletion"
      :title="$t('DELETE_CONTACT.CONFIRM.TITLE')"
      :message="$t('DELETE_CONTACT.CONFIRM.MESSAGE')"
      :message-value="confirmDeleteMessage"
      :confirm-text="$t('DELETE_CONTACT.CONFIRM.YES')"
      :reject-text="$t('DELETE_CONTACT.CONFIRM.NO')"
    />
    <div
      v-if="isDropdownVisible"
      class="multiselect-wrap--small mt-2 contact-assigned-section"
    >
      <label class="contact-field-label">
        {{ $t('CONTACTS_PAGE.LIST.TABLE_HEADER.ASSIGNED_TO') }}
      </label>
      <multiselect-dropdown
        class="contact-assigned-dropdown"
        :options="agentsList"
        :selected-item="assignedAgent"
        :multiselector-title="$t('AGENT_MGMT.MULTI_SELECTOR.TITLE.AGENT')"
        :multiselector-placeholder="$t('AGENT_MGMT.MULTI_SELECTOR.PLACEHOLDER')"
        :no-search-result="
          $t('AGENT_MGMT.MULTI_SELECTOR.SEARCH.NO_RESULTS.AGENT')
        "
        :input-placeholder="
          $t('AGENT_MGMT.MULTI_SELECTOR.SEARCH.PLACEHOLDER.AGENT')
        "
        @click="onClickAssignAgent"
      />
    </div>

    <woot-confirm-modal
      ref="cancelMeetingDialog"
      :title="$t('EDIT_CONTACT.CANCEL_MEETING_CONFIRM_TITLE')"
      :description="$t('EDIT_CONTACT.CANCEL_MEETING_CONFIRM_DESCRIPTION')"
      :confirm-label="$t('EDIT_CONTACT.CANCEL_MEETING_CONFIRM')"
      :cancel-label="$t('EDIT_CONTACT.CANCEL_MEETING_KEEP')"
    />
  </div>
</template>
<script>
import { mixin as clickaway } from 'vue-clickaway';
import timeMixin from 'dashboard/mixins/time';
import ContactInfoRow from './ContactInfoRow';
import ContactLabel from 'dashboard/routes/dashboard/contacts/components/ContactLabels.vue';
import ContactSummaryButton from 'dashboard/components/ContactSummaryButton.vue';
import LeadQualityButton from 'dashboard/components/LeadQualityButton.vue';
import LeadQualityCrown from 'dashboard/components/LeadQualityCrown.vue';
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';
import SocialIcons from './SocialIcons';
import DraggableFile from '../../../../components/widgets/WootWriter/Draggable.vue';
import EditContact from './EditContact';
import NewConversation from './NewConversation';
import ContactMergeModal from 'dashboard/modules/contact/ContactMergeModal';
import SetRemainderModal from 'dashboard/modules/contact/SetRemainderModal';
import alertMixin from 'shared/mixins/alertMixin';
import adminMixin from '../../../../mixins/isAdmin';
import { mapGetters, mapActions } from 'vuex';
import { getCountryFlag } from 'dashboard/helper/flag';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { ensureMicrophonePermission } from 'dashboard/helper/microphonePermission';
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown.vue';
import axios from 'axios';
import { tr } from 'date-fns/locale';
import BoardSelectionModal from './BoardSelectionModal.vue';
import LeadResponseWatch from 'dashboard/components/widgets/LeadResponseWatch.vue';
import { effectiveWaitingSinceUnixForConversation } from 'dashboard/helper/leadResponseWatch';
import StatusSelectionModal from './StatusSelectionModal.vue';
import StateSelectionModal from './StateSelectionModal.vue';
import SetRemainderFollowUpModal from '../../../../modules/contact/SetRemainderFollowUpModal.vue';
import CallViaDropdown from 'dashboard/components/widgets/CallViaDropdown.vue';
import {
  canBookMeeting,
  canCancelMeeting,
  canRescheduleMeeting,
  isMeetingOngoing,
  resolveMeetingLifecycle,
  MEETING_LIFECYCLE,
} from 'dashboard/helper/contactMeetingLifecycle';
import { persistContactMeetingUi } from 'dashboard/helper/contactMeetingUiSync';
let token;
let device;
let call;
export default {
  components: {
    ContactLabel,
    ContactSummaryButton,
    LeadQualityButton,
    LeadQualityCrown,
    ContactInfoRow,
    EditContact,
    Thumbnail,
    SocialIcons,
    NewConversation,
    ContactMergeModal,
    SetRemainderModal,
    DraggableFile,
    MultiselectDropdown,
    BoardSelectionModal,
    StatusSelectionModal,
    StateSelectionModal,
    SetRemainderFollowUpModal,
    LeadResponseWatch,
    CallViaDropdown,
  },
  mixins: [alertMixin, adminMixin, clickaway, timeMixin],
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
    channelType: {
      type: String,
      default: '',
    },
    showAvatar: {
      type: Boolean,
      default: true,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    closeIconName: {
      type: String,
      default: 'dismiss',
    },
    pipelineContact: {
      type: Boolean,
      default: false,
    },
    reminderFlag: {
      type: Boolean,
    },
    isModalView: {
      type: Boolean,
      default: false,
    },
    isConversationSidebar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showEditModal: false,
      showConversationModal: false,
      showMergeModal: false,
      showRemainderModal: false,
      showDeleteModal: false,
      showDragmodal: false,
      showCallButton: true,
      showOptions: false,
      domesticInboxes: [],
      seconds: 0,
      minutes: 0,
      hours: 0,
      selectedContact: null,
      conversationId: '',
      datePart: '',
      timeWithoutZ: '',
      updatedDate: '',
      updatedTime: '',
      demo_time: null,
      formatted: false,
      isDropdownVisible: false,
      agentsList: [],
      assignedAgent: null,
      userIcon: 'user',
      isCreatingCall: false,
      selectedAgent: null,
      selectedBoard: null,
      selectedStatus: null,
      stateList: [],
      isTransfering: false,
      loadingSelection: false,
      showBoardModal: false,
      showStatusModal: false,
      showStateModal: false,
      selectedState: null,
      setReminder: '',
      showRemainderFollowupModal: false,
      latestSummaryMetadata: null,
      contactSummaryError: null,
      latestLeadQualityMetadata: null,
      leadQualityError: null,
      profileLinkCopied: false,
      profileLinkCopyTimer: null,
      contactModalHydrating: false,
    };
  },
  watch: {
    'contact.id'(newId, oldId) {
      this.latestSummaryMetadata = null;
      this.contactSummaryError = null;
      this.latestLeadQualityMetadata = null;
      this.leadQualityError = null;
      if (newId !== oldId) {
        this.selectedBoard = null;
        this.selectedStatus = null;
        this.selectedState = null;
        this.stateList = [];
        this._pipelineStatusBoardId = null;
        if (this.isModalView && newId) {
          this.contactModalHydrating = true;
        }
      }
      this.scheduleCrmSync();
    },
    'uiFlags.isFetchingItem'(isFetching) {
      if (!this.isModalView) {
        return;
      }
      if (isFetching) {
        this.contactModalHydrating = true;
      } else {
        this.tryFinishContactModalHydrating();
      }
    },
    loadingSelection(isLoading) {
      if (!this.isModalView) {
        return;
      }
      if (isLoading) {
        this.contactModalHydrating = true;
      } else {
        this.tryFinishContactModalHydrating();
      }
    },
    contactCrmSignature() {
      this.scheduleCrmSync();
    },
    boardOptionsSignature() {
      this.scheduleCrmSync();
    },
    stateOptionsSignature() {
      this.scheduleCrmSync();
    },
    formatted(newVal) {
      console.log('New Val', newVal);
      this.getConversationData();
    },
    'contact.assignee': {
      handler() {
        this.syncAssignedAgentFromContact();
      },
      deep: true,
    },
    'contact.assignee_id'() {
      this.syncAssignedAgentFromContact();
    },
    showContactDetailsLoadingOverlay: {
      handler(isLoading) {
        if (this.isModalView) {
          this.$emit('modal-content-loading', isLoading);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.setReminder = this.getFormattedReminder(this.contact);
    this.getConversationData();
    if (!this.setReminder) {
      this.formattedChatDateTime;
    }
    this.fetchAgents();
    this.fetchDomesticInboxes();
    this.getBoards();
    this.getStates();
    this.scheduleCrmSync();
    this.syncAssignedAgentFromContact();
    if (this.isAdmin) {
      this.isDropdownVisible = true;
    }
    console.log(this.contact, 'this is the contact');

    // Listen for demo meeting updates
    bus.$on('demo-meeting-updated', this.onDemoMeetingUpdated);

    if (this.isModalView && this.contact?.id) {
      this.contactModalHydrating = true;
    }
  },
  beforeDestroy() {
    if (this._crmSyncTimer) {
      clearTimeout(this._crmSyncTimer);
      this._crmSyncTimer = null;
    }
    if (this.profileLinkCopyTimer) {
      clearTimeout(this.profileLinkCopyTimer);
      this.profileLinkCopyTimer = null;
    }
    bus.$off('demo-meeting-updated', this.onDemoMeetingUpdated);
    if (this.isModalView) {
      this.$emit('modal-content-loading', false);
    }
  },
  computed: {
    isConversationPage() {
      return this.$route.path !== '/app/accounts/1/contacts';
    },
    isContactPage() {
      return this.$route.path === '/app/accounts/1/contacts';
    },
    isContactProfilePage() {
      return this.$route?.name === 'contact_profile_dashboard';
    },
    showOpenContactProfileButton() {
      return !this.isContactProfilePage;
    },
    formattedTime() {
      return (
        this.pad(this.hours) +
        ':' +
        this.pad(this.minutes) +
        ':' +
        this.pad(this.seconds)
      );
    },
    showContactDetailsLoadingOverlay() {
      if (this.isModalView) {
        return this.contactModalHydrating;
      }
      return this.loadingSelection;
    },
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
      accountId: 'getCurrentAccountId',
      baseUrl: 'getbaseUrl',
      currentUserId: 'getCurrentUserID',
      currentChat: 'getSelectedChat',
      current_userId: 'getCurrentUser',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
    }),
    formattedChatDateTime() {
      this.formatted = !this.formatted;
      let date = null;
      if (this.demo_time != null) {
        date = new Date(this.demo_time);
      } else if (this.currentChat.demo_time != null) {
        const dateTimeStr = this.currentChat.demo_time;
        date = new Date(dateTimeStr);
      }

      if (date === null || isNaN(date)) {
        this.datePart = '';
        this.timeWithoutZ = '';
        this.setReminder = 'Not Available';
        return;
      }
      const formattedDate = date.toLocaleDateString(navigator.language, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      });
      const formattedTime = date
        .toLocaleTimeString(navigator.language, {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        })
        .replace('am', 'AM')
        .replace('pm', 'PM'); // Ensuring AM/PM in uppercase
      this.datePart = formattedDate;
      this.timeWithoutZ = formattedTime;
      this.setReminder = `${formattedDate}, ${formattedTime}`;
      this.contact.additional_attributes.calendar_timings = this.setReminder;
    },

    currentContact() {
      return this.$store.getters['contacts/getContact'](
        this.currentChat.meta.sender.id
      );
    },
    contactResponseWatchData() {
      const senderId = this.currentChat?.meta?.sender?.id;
      const sameContact =
        this.currentChat &&
        senderId &&
        Number(senderId) === Number(this.contact?.id);
      if (sameContact) {
        const inboxId = this.currentChat?.inbox_id;
        const inbox = inboxId
          ? this.$store.getters['inboxes/getInbox'](inboxId)
          : null;
        const channelType = inbox?.channel_type || null;
        const result = effectiveWaitingSinceUnixForConversation(
          this.currentChat,
          null,
          channelType,
          { store: this.$store, accountId: this.accountId }
        );
        if (result == null) return { unix: null, forceRed: false };
        if (typeof result === 'object') return result;
        return { unix: result, forceRed: false };
      }
      const ws = this.contact?.response_wait_waiting_since;
      if (ws == null || ws === '' || Number(ws) <= 0)
        return { unix: null, forceRed: false };
      return { unix: Number(ws), forceRed: false };
    },
    contactProfileLink() {
      let baseUrl = `/app/accounts/${this.$route.params.accountId}/contacts/${this.contact.id}`;
      return this.pipelineContact ? `${baseUrl}?pipelineContact=true` : baseUrl;
    },
    contactProfileAbsoluteUrl() {
      if (typeof window === 'undefined') {
        return this.contactProfileLink;
      }
      return `${window.location.origin}${this.contactProfileLink}`;
    },
    additionalAttributes() {
      return this.contact.additional_attributes || {};
    },
    companyNameTooltip() {
      const name = this.additionalAttributes.company_name;
      return name && name.length > 20 ? name : '';
    },
    contactSummaryText() {
      const meta =
        this.contact.contact_summary_metadata || this.latestSummaryMetadata;
      if (!meta || typeof meta !== 'object') return '';
      return meta.summary ?? meta.summary ?? '';
    },
    hasContactSummary() {
      const meta =
        this.contact.contact_summary_metadata || this.latestSummaryMetadata;
      if (!meta || typeof meta !== 'object') return false;
      return !!(meta.summary ?? meta.summary);
    },
    contactSummaryGeneratedAt() {
      const meta =
        this.contact.contact_summary_metadata || this.latestSummaryMetadata;
      if (!meta || typeof meta !== 'object') return '';
      const raw = meta.generated_at ?? meta.generated_at;
      if (!raw || typeof raw !== 'string') return '';
      try {
        const date = new Date(raw);
        if (Number.isNaN(date.getTime())) return '';
        return date.toLocaleString('en-US', {
          year: 'numeric',
          month: 'short',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      } catch {
        return '';
      }
    },
    showContactSummaryTimestamp() {
      if (!this.contactSummaryGeneratedAt) return false;
      const noConversationMessage = 'No previous conversation found.';
      return (this.contactSummaryText || '').trim() !== noConversationMessage;
    },
    isContactSummaryEnabled() {
      return this.isFeatureEnabledonAccount(
        this.accountId,
        FEATURE_FLAGS.CONTACT_SUMMARY
      );
    },
    isLeadQualityEnabled() {
      return this.isFeatureEnabledonAccount(
        this.accountId,
        FEATURE_FLAGS.LEAD_QUALITY
      );
    },
    hasDemoMeeting() {
      return this.meetingLifecycle !== MEETING_LIFECYCLE.NONE;
    },
    meetingLifecycle() {
      return resolveMeetingLifecycle(this.contact);
    },
    canBookMeeting() {
      return canBookMeeting(this.contact);
    },
    canRescheduleMeeting() {
      return canRescheduleMeeting(this.contact);
    },
    canCancelMeeting() {
      return canCancelMeeting(this.contact);
    },
    isMeetingOngoing() {
      return isMeetingOngoing(this.contact);
    },
    formattedDemoTiming() {
      if (this.meetingLifecycle === MEETING_LIFECYCLE.NONE) {
        return '';
      }
      if (this.contact?.meeting_starts_at) {
        const date = new Date(this.contact.meeting_starts_at);
        if (!Number.isNaN(date.getTime())) {
          return date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });
        }
      }
      const raw = this.additionalAttributes.demo_timing;
      if (!raw || typeof raw !== 'string' || raw.trim() === '') {
        return '';
      }
      try {
        // Handle format like "Fri, Jan 30, 2026, 5:45:0 PM +0530"
        // Remove day name and extra commas, fix single-digit seconds
        let sanitized = raw;
        // Remove day name (Mon, Tue, etc.)
        sanitized = sanitized.replace(/^[A-Za-z]{3},\s*/, '');
        // Remove remaining commas
        sanitized = sanitized.replace(/,/g, '');
        // Fix single digit time parts: "5:45:0" -> "05:45:00"
        sanitized = sanitized.replace(/(\s)(\d):/, '$10$2:');
        sanitized = sanitized.replace(/:(\d)(\s)/, ':0$1$2');
        sanitized = sanitized.replace(/:(\d):/, ':0$1:');
        // Convert +0530 to +05:30 format for better parsing
        sanitized = sanitized.replace(/\+(\d{2})(\d{2})$/, '+$1:$2');

        const date = new Date(sanitized);
        if (isNaN(date.getTime())) {
          // Try parsing original with Date.parse
          const fallbackDate = new Date(raw.replace(/,/g, ''));
          if (!isNaN(fallbackDate.getTime())) {
            return fallbackDate.toLocaleString('en-US', {
              year: 'numeric',
              month: 'short',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            });
          }
          return raw;
        }
        const options = {
          year: 'numeric',
          month: 'short',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        };
        return date.toLocaleString('en-US', options);
      } catch (e) {
        return raw;
      }
    },
    demoMeetingLink() {
      return this.additionalAttributes.meeting_link || '';
    },
    hasDemoMeetingLink() {
      if (this.meetingLifecycle === MEETING_LIFECYCLE.NONE) {
        return false;
      }
      const link = this.demoMeetingLink;
      return typeof link === 'string' && link.trim().length > 0;
    },
    location() {
      const {
        country = '',
        city = '',
        country_code: countryCode,
      } = this.additionalAttributes;
      const cityAndCountry = [city, country].filter(item => !!item).join(', ');

      if (!cityAndCountry) {
        return '';
      }
      return this.findCountryFlag(countryCode, cityAndCountry);
    },
    socialProfiles() {
      const {
        social_profiles: socialProfiles,
        screen_name: twitterScreenName,
      } = this.additionalAttributes;

      return { twitter: twitterScreenName, ...(socialProfiles || {}) };
    },
    // Delete Modal
    confirmDeleteMessage() {
      return ` ${this.contact.name}?`;
    },
    isSpecialRoute() {
      const { path, query } = this.$route;
      // Apply special styles only to routes matching the pattern and exclude those with `page` query parameter
      return (
        path.startsWith('/app/accounts') &&
        path.includes('/contacts/') &&
        !query.page // Exclude routes with `page` query parameter
      );
    },
    iscontainIcon() {
      const { path, query } = this.$route;
      const isContactsRoute = /^\/app\/accounts\/\d+\/contacts\/?$/.test(path);
      const hasPageQuery = !!query.page;
      console.log('isContactsRoute', isContactsRoute);
      console.log('hasPage', hasPageQuery);
      console.log(isContactsRoute && hasPageQuery);
      return isContactsRoute || hasPageQuery;
    },
    dynamicClasses() {
      // If it's a modal view, always show the header
      if (this.isModalView) {
        return '';
      }
      // Otherwise, use route detection
      return this.isSpecialRoute ? 'display_none' : '';
    },
    Moredetail() {
      // return !this.iscontainIcon ? "" : "display_none";
      return this.isSpecialRoute ? '' : 'display_none';
    },
    boards() {
      // return this.$store.getters['pipelines/getAllBoards'];
      console.log('My Boards', this.$store.getters['pipelines/getAllBoards']);
      return [...this.$store.getters['pipelines/getAllBoards']];
    },
    states() {
      // return this.$store.getters['pipelines/getAllStatus'];
      return [...this.$store.getters['pipelines/getAllStatus']];
    },
    state() {
      console.log('My state', this.$store.getters['pipelines/getAllStatus']);
      // return [
      //   ...this.$store.getters['pipelines/getAllStatus'],
      // ];
      return this.$store.getters['pipelines/getAllStatus'] || [];
    },
    contactCrmSignature() {
      const { contact } = this;
      if (!contact?.id) return '';
      return `${contact.id}:${contact.board_id}:${contact.status_id}:${contact.state_id}`;
    },
    boardOptionsSignature() {
      const boards = this.$store.getters['pipelines/getAllBoards'] || [];
      return boards.map(board => board.id).join(',');
    },
    stateOptionsSignature() {
      const states = this.$store.getters['pipelines/getAllStatus'] || [];
      return states.map(state => state.id).join(',');
    },
    canMove() {
      const boardChanged = this.selectedBoard !== this.contact.board_id;
      const stateChanged = this.selectedStatus !== this.contact.status_id;

      return (
        this.selectedBoard &&
        this.selectedStatus &&
        this.stateList.length > 0 &&
        (boardChanged || stateChanged)
      );
    },
  },
  methods: {
    ...mapActions('globalModals', ['showScheduleDemoModal']),
    onContactSummary(payload) {
      if (!payload) return;
      this.contactSummaryError = null;
      if (payload.contact_summary_metadata) {
        this.latestSummaryMetadata = payload.contact_summary_metadata;
        this.$store.dispatch('contacts/updateContact', {
          id: this.contact.id,
          contact_summary_metadata: payload.contact_summary_metadata,
        });
      } else if (payload.summary != null && payload.summary !== '') {
        this.latestSummaryMetadata = { summary: payload.summary };
      }
    },
    onContactSummaryError(message) {
      this.contactSummaryError =
        message || 'Something went wrong. Please try again later.';
    },
    onLeadQuality(payload) {
      if (!payload) return;
      this.leadQualityError = null;
      if (payload.lead_quality_metadata) {
        this.latestLeadQualityMetadata = payload.lead_quality_metadata;
        this.$store.dispatch('contacts/updateContact', {
          id: this.contact.id,
          lead_quality_metadata: payload.lead_quality_metadata,
        });
      }
    },
    onLeadQualityError(message) {
      this.leadQualityError =
        message || this.$t('LEAD_QUALITY.ERROR') || 'Something went wrong.';
    },
    onOpenLeadQualityFromCrown() {
      this.leadQualityError = null;
      const meta =
        this.contact.lead_quality_metadata || this.latestLeadQualityMetadata;
      if (!meta || typeof meta !== 'object' || Object.keys(meta).length === 0) {
        return;
      }
      this.$refs.leadQualityButtonRef?.openResultFromMetadata?.(meta);
    },
    copyContactProfileLink() {
      this.copyToClipboard(
        this.contactProfileAbsoluteUrl,
        this.$t('CONTACT_PANEL.COPY_PROFILE_LINK_ALERT_LABEL')
      )
        .then(() => {
          this.showProfileLinkCopiedTick();
        })
        .catch(() => {});
    },
    showProfileLinkCopiedTick() {
      this.profileLinkCopied = true;
      if (this.profileLinkCopyTimer) {
        clearTimeout(this.profileLinkCopyTimer);
      }
      this.profileLinkCopyTimer = setTimeout(() => {
        this.profileLinkCopied = false;
        this.profileLinkCopyTimer = null;
      }, 2000);
    },
    copyToClipboard(text, label) {
      const notifySuccess = () => {
        this.showAlert(`${label} copied to clipboard`);
      };
      const notifyFailure = () => {
        this.showAlert(`Failed to copy ${label}`);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard
          .writeText(text)
          .then(() => {
            notifySuccess();
          })
          .catch(() => {
            notifyFailure();
            return Promise.reject();
          });
      }

      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        document.body.removeChild(textArea);
        notifySuccess();
        return Promise.resolve();
      } catch (err) {
        document.body.removeChild(textArea);
        notifyFailure();
        return Promise.reject();
      }
    },
    getFormattedReminder() {
      const raw = this.contact?.additional_attributes?.calendar_timings;

      if (!raw || typeof raw !== 'string' || raw.trim() === '') {
        return '';
      }

      let sanitized = raw.replace(/,/g, '');

      sanitized = sanitized.replace(
        /(\d{1,2}:\d{1,2}):(\d{1})(\s[AP]M)/,
        '$1:0$2$3'
      );
      sanitized = sanitized.replace(
        /(\d{1,2}:\d{1,2}):(\d{2})(\s[AP]M)/,
        '$1:$2$3'
      );

      const date = new Date(sanitized);

      if (isNaN(date.getTime())) {
        console.warn('Invalid calendar time:', raw);
        return '';
      }

      const options = {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      };

      return date.toLocaleString('en-US', options);
    },
    async copyMeetingLink() {
      if (!this.demoMeetingLink) return;
      try {
        await navigator.clipboard.writeText(this.demoMeetingLink);
        this.showAlert(this.$t('EDIT_CONTACT.MEETING_LINK_COPIED'));
      } catch (err) {
        console.error('Failed to copy meeting link:', err);
      }
    },
    onDemoMeetingUpdated(payload) {
      if (Number(payload?.contactId) !== Number(this.contact?.id)) {
        return;
      }
      persistContactMeetingUi(this.$store, payload);
    },
    openScheduleDemoMeetingModal(intent = 'book') {
      if (!this.reminderFlag) {
        this.showAlert('Not active for this account');
        return;
      }
      if (intent === 'book' && this.hasDemoMeeting) {
        this.showAlert(this.$t('EDIT_CONTACT.MEETING_IN_PROGRESS'));
        return;
      }
      this.showScheduleDemoModal({
        ...this.contact,
        schedule_intent: intent,
      });
    },
    openBookMeetingModal() {
      this.openScheduleDemoMeetingModal('book');
    },
    openRescheduleMeetingModal() {
      this.openScheduleDemoMeetingModal('reschedule');
    },
    async confirmCancelMeeting() {
      if (!this.canCancelMeeting) {
        this.showAlert(this.$t('EDIT_CONTACT.MEETING_IN_PROGRESS'));
        return;
      }
      const meetingId = this.contact?.primary_contact_meeting_id;
      if (!meetingId) {
        this.showAlert(this.$t('EDIT_CONTACT.CANCEL_MEETING_MISSING'));
        return;
      }
      const confirmed = await this.$refs.cancelMeetingDialog?.showConfirmation();
      if (!confirmed) return;

      try {
        await this.$store.dispatch('contacts/cancel_demo_meeting', {
          contactId: this.contact.id,
          meetingId,
        });
        if (typeof bus !== 'undefined' && bus && bus.$emit) {
          bus.$emit('demo-meeting-updated', {
            contactId: this.contact.id,
            demo_timing: null,
            meeting_link: null,
            demo_subject: null,
            meeting_description: null,
            meeting_starts_at: null,
            meeting_ends_at: null,
          });
        }
        this.$set(this.contact, 'meeting_starts_at', null);
        this.$set(this.contact, 'meeting_ends_at', null);
        this.$set(this.contact, 'meeting_lifecycle', 'none');
        this.$set(this.contact, 'primary_contact_meeting_id', null);
        this.$set(this.contact, 'can_book_meeting', true);
        this.$set(this.contact, 'can_reschedule_meeting', false);
        this.$set(this.contact, 'can_cancel_meeting', false);
        if (this.contact.additional_attributes) {
          this.$delete(this.contact.additional_attributes, 'demo_timing');
          this.$delete(this.contact.additional_attributes, 'meeting_link');
          this.$delete(this.contact.additional_attributes, 'demo_subject');
        }
        this.showAlert(this.$t('EDIT_CONTACT.CANCEL_MEETING_SUCCESS'));
      } catch (error) {
        this.showAlert(
          error.response?.data?.error ||
            error.message ||
            this.$t('EDIT_CONTACT.CANCEL_MEETING_ERROR')
        );
      }
    },
    toggleBoardModal() {
      this.showBoardModal = !this.showBoardModal;
    },
    hasCalendarReminder(element) {
      return !!element?.additional_attributes?.calendar_timings;
    },
    async handleBoardSelection(board) {
      this.selectedBoard = board;
      this.showBoardModal = false;
      await this.onBoardChange();
      await this.moveItem();
    },
    closeDropdown() {
      this.showBoardModal = false;
    },
    toggleStatusModal() {
      this.showStatusModal = !this.showStatusModal;
    },
    handleStatusSelection(state) {
      this.selectedStatus = state;
      this.showStatusModal = false;
      this.moveItem(); // Call the move logic if needed
    },
    toggleStateModal() {
      this.showStateModal = !this.showStateModal;
    },
    handleStateSelection(state) {
      this.showStateModal = false;
      if (!state?.id) {
        return;
      }
      this.selectedState = state;
      if (this.idsMatch(state.id, this.contact?.state_id)) {
        return;
      }
      this.assignContactState(state.id);
    },
    async handleBoardRemove(boardId) {
      if (!boardId) return;

      const data = { boardId: null, contactId: this.contact.id };
      const statusData = { statusId: null, contactId: this.contact.id };

      try {
        const response = await this.$store.dispatch(
          'contacts/assignBoard',
          data
        );
        const statusResponse = await this.$store.dispatch(
          'pipelines/assignStatus',
          statusData
        );
        if (response.status === 200 && statusResponse.status === 200) {
          this.selectedBoard = null;
          this.selectedStatus = null;
          this.stateList = [];
          this._pipelineStatusBoardId = null;
          this.$store.dispatch('contacts/updateContact', {
            id: this.contact.id,
            board_id: null,
            status_id: null,
          });
          bus.$emit('on-assign');
          bus.$emit('pipeline-contact-board-changed', {
            contactId: this.contact.id,
            boardId: null,
          });
          this.notifyPipelineBoardDataReload();
          bus.$emit('reload-contact-updated', true);
        }
      } catch (error) {
        this.$toast.error('An error occurred while removing the board');
      }
    },
    notifyPipelineBoardDataReload() {
      const boardId = Number(this.$route.params.board_id);
      const getAppliedFiltersByBoard = this.$store.getters[
        'pipelines/getAppliedBoardFiltersByBoard'
      ];
      const scopedFilters =
        typeof getAppliedFiltersByBoard === 'function' && boardId
          ? getAppliedFiltersByBoard(boardId) || []
          : [];

      if (!(Array.isArray(scopedFilters) && scopedFilters.length > 0)) {
        bus.$emit('reloaad-pipeline');
      }
    },
    async handleStateRemove() {
      if (!this.contact?.id) return;

      const data = {
        stateId: null,
        contactId: this.contact.id,
        description: '',
      };

      try {
        const response = await this.$store.dispatch(
          'contacts/assignState',
          data
        );
        if (response.status === 200) {
          this.selectedState = null;
          this.stateRemark = '';
          this.$store.dispatch('contacts/updateContact', {
            id: this.contact.id,
            state_id: null,
            state_name: null,
          });
          // this.$toast.success('State removed successfully');
          bus.$emit('on-assign'); // if needed to notify other components
        }
      } catch (error) {
        console.error('❌ Error removing state:', error);
        this.$toast.error('Failed to remove state');
      }
    },

    closePanel() {
      this.$emit('toggle-panel');
      // Select and hide elements with specific classes
      const sidebarElement = document.querySelector(
        '.conversation-sidebar-wrap'
      );
      const overlayElement = document.querySelector('.modal-overlay-v1');

      if (sidebarElement) {
        sidebarElement.style.display = 'none';
      }
      if (overlayElement) {
        overlayElement.style.display = 'none';
      }

      this.$emit('cancel'); // Emit cancel event if needed by parent component
    },
    toggleMergeModal() {
      this.showMergeModal = !this.showMergeModal;
    },
    toggleReminderModal() {
      this.showRemainderModal = !this.showRemainderModal;
    },
    toggleReminderFollowUpModal() {
      this.showRemainderFollowupModal = !this.showRemainderFollowupModal;
    },
    toggleScheduledDraftsModal() {
      if (this.currentChat && this.currentChat.id) {
        const accountId = this.$route.params.accountId;
        this.$router.push({
          name: 'scheduled_drafts',
          params: {
            accountId: accountId,
            conversation_id: this.currentChat.id,
          },
        });
      }
    },
    toggleEditModal() {
      this.showEditModal = !this.showEditModal;
    },
    onPanelToggle() {
      this.$emit('toggle-panel');
    },
    toggleConversationModal() {
      this.showConversationModal = !this.showConversationModal;
    },
    handleChatMessengerClick() {
      this.toggleConversationModal();
      this.closeOptions();
    },
    handleMergeClick() {
      this.openMergeModal();
      this.closeOptions();
    },
    handleDeleteClick() {
      this.toggleDeleteModal();
      this.closeOptions();
    },
    handleRemainderClick() {
      this.openRemainderModal();
      this.closeOptions();
    },
    handletoggleDropdown() {
      this.toggleDropdown();
      this.closeOptions();
    },
    toggleOptionsVisibility() {
      this.showOptions = !this.showOptions; // Toggles the visibility of the options div
    },
    closeOptions() {
      this.showOptions = false;
    },
    startTimer() {
      this.timerRunning = true;
      this.timer = setInterval(this.updateTimer, 1000);
    },
    stopTimer() {
      clearInterval(this.timer);
      this.timerRunning = false;
    },
    updateTimer() {
      this.seconds++;
      if (this.seconds === 60) {
        this.seconds = 0;
        this.minutes++;
        if (this.minutes === 60) {
          this.minutes = 0;
          this.hours++;
        }
      }
    },
    resetTimer() {
      this.stopTimer();
      this.selectedContact = null;
      this.seconds = 0;
      this.minutes = 0;
      this.hours = 0;
    },
    async CallHangup() {
      console.log('Call Disconnected');
      call.disconnect();
      this.$store.dispatch('contacts/toggleholdCallAvailableStatusFalse');
    },
    async updateUIAcceptedOutgoingCall() {
      this.startTimer();
    },

    async updateUIDisconnectedOutgoingCall() {
      alert('Call Ended');
      this.showDragmodal = false;
      this.resetTimer();
      console.log('::::::::::::Call has ended::::::::::');
      window.call = null;
    },
    async makeOutgoingCall() {
      try {
        const contact = this.contact;
        var params = {
          To: contact.phone_number,
          account_id: this.accountId,
          contact_id: contact.id,
          userId: this.currentUserId,
        };
        if (device) {
          console.log(`Attempting to call ${params.To} ...`);
          call = await device.connect({ params });
          window.call = call;
          call.on('accept', this.updateUIAcceptedOutgoingCall);
          call.on('disconnect', this.updateUIDisconnectedOutgoingCall);
          call.on('cancel', this.updateUIDisconnectedOutgoingCall);
        } else {
          console.log('Unable to make call.');
        }
      } catch (error) {
        console.error(
          'Error making outgoing call:-------------------------',
          error
        );
      }
    },

    async fetchDomesticInboxes() {
      try {
        const response = await window.axios.get(
          `/domestic_calls/domestic_inboxes?account_id=${this.accountId}`
        );

        this.domesticInboxes = response.data.map(item => ({
          label: item.name,
          value: item.id,
          caller_id: item.caller_id,
          inboxObject: item,
        }));
      } catch (error) {
        console.error('Error fetching domestic inboxes:', error);
        this.domesticInboxes = [];
        this.showAlert(this.$t('CONTACT_PANEL.DOMESTIC_INBOX_FETCH_FAILED'), {
          success: false,
        });
      }
    },

    async initializeDomesticCall(inboxId) {
      const inbox = this.domesticInboxes.find(
        item => Number(item.value) === Number(inboxId)
      );
      if (!inbox) {
        this.showAlert(this.$t('CONTACT_PANEL.DOMESTIC_INBOX_NOT_FOUND'), {
          success: false,
        });
        await this.fetchDomesticInboxes();
        return;
      }

      await this.createDomesticCall(inbox);
    },

    contactPhoneNumber() {
      return (this.contact && this.contact.phone_number
        ? this.contact.phone_number
        : ''
      )
        .toString()
        .trim();
    },

    async createDomesticCall(inbox) {
      if (this.isCreatingCall) {
        this.showAlert(this.$t('CONTACT_PANEL.DOMESTIC_CALL_IN_PROGRESS'), {
          success: false,
        });
        return;
      }
      if (!this.contactPhoneNumber()) {
        this.showAlert(this.$t('CONTACT_PANEL.DOMESTIC_CALL_PHONE_REQUIRED'));
        return;
      }

      this.isCreatingCall = true;

      const payload = {
        inbox_id: inbox.value,
        contact_id: this.contact.id,
        source_id: this.contact.phone_number,
        additional_attributes: {
          mail_subject: '',
        },
        message: {
          content: 'Indian Domestic Calls',
        },
        assignee_id: this.current_userId.id,
      };

      try {
        const response = await axios.get(
          `${this.baseUrl}/api/v1/accounts/${this.accountId}/search/conversations?q=${this.contact.phone_number}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'api-access-token': this.$store.getters.getCurrentUser
                .access_token,
            },
          }
        );

        let conversationId;

        const existingConversations = response.data.payload.conversations;
        if (existingConversations && existingConversations.length > 0) {
          conversationId = existingConversations[0].conversation_id;
        } else {
          const createResponse = await axios.post(
            `${this.baseUrl}/api/v1/accounts/${this.accountId}/conversations`,
            payload,
            {
              headers: {
                'Content-Type': 'application/json',
                'api-access-token': this.$store.getters.getCurrentUser
                  .access_token,
              },
            }
          );
          conversationId = createResponse.data.conversationId;
        }

        const callPayload = {
          phone_number: this.contact.phone_number,
          account_id: this.accountId,
          inbox_id: inbox.value,
          agent_id: this.current_userId.id,
          conversation_id: conversationId,
        };

        const callResponse = await window.axios.post(
          `${this.baseUrl}/domestic_calls/create_call`,
          callPayload
        );

        if (callResponse.data.success === true) {
          this.showAlert(callResponse.data.message);
        } else {
          this.showAlert(
            callResponse.data.message ||
              this.$t('CONTACT_PANEL.DOMESTIC_CALL_FAILED'),
            { success: false }
          );
        }
      } catch (error) {
        console.error('Error:', error);
        this.showAlert(this.$t('CONTACT_PANEL.DOMESTIC_CALL_FAILED'), {
          success: false,
        });
      } finally {
        this.isCreatingCall = false;
      }
    },

    async startupClient() {
      if (!this.contactPhoneNumber()) {
        this.showAlert(this.$t('CONTACT_PANEL.DOMESTIC_CALL_PHONE_REQUIRED'));
        return;
      }

      console.log('Requesting Access Token...');
      const contact = this.contact;
      this.selectedContact = contact;
      console.log('My COntact:::::', contact);
      let data; // Declare data variable outside the try block

      // Request microphone permission FIRST before opening modal
      const hasPermission = await this.getAudioDevices();
      if (!hasPermission) {
        this.showAlert(
          'Please allow access to your microphone in the browser to make a call.'
        );
        return;
      }

      try {
        this.$store.dispatch('contacts/toggleholdCallAvailableStatusTrue');
        this.showDragmodal = !this.showDragmodal;
        console.log('Contact in yourMethod:', contact);
        console.log('User Id', this.currentUserId);
        // Remove redeclaration of data variable here
        const response = await axios.get(`${this.baseUrl}/twilio/token`, {
          params: {
            To: contact.phone_number,
            account_id: this.accountId,
            user_id: this.currentUserId,
          },
        });
        data = response.data;

        token = data.token;
        console.log('got token' + token);
        await this.intitializeDevice();
        this.makeOutgoingCall();
      } catch (err) {
        alert(data.message);
        this.showDragmodal = !this.showDragmodal;
        console.log(
          'An error occurred. See your browser console for more information.'
        );
      }
    },

    async getAudioDevices() {
      // Twilio outbound only — shared helper skips repeat prompts.
      return ensureMicrophonePermission();
    },
    addDeviceListeners(device) {
      device.on('registered', function() {
        console.log('Twilio.Device Ready to make and receive calls!');
      });
      device.on('error', function(error) {
        console.log('Twilio.Device Error: ' + error.message);
      });
    },
    async intitializeDevice() {
      console.log('Initializing device');
      device = new Twilio.Device(token, {
        logLevel: 1,
      });
      this.addDeviceListeners(device);
      device.register();
    },
    toggleDeleteModal() {
      this.showDeleteModal = !this.showDeleteModal;
    },
    confirmDeletion() {
      this.deleteContact(this.contact);
      this.closeDelete();
    },
    closeDelete() {
      this.showDeleteModal = false;
      this.showConversationModal = false;
      this.showEditModal = false;
    },
    findCountryFlag(countryCode, cityAndCountry) {
      try {
        const countryFlag = countryCode ? getCountryFlag(countryCode) : '🌎';
        return `${cityAndCountry} ${countryFlag}`;
      } catch (error) {
        return '';
      }
    },
    async deleteContact({ id }) {
      try {
        await this.$store.dispatch('contacts/delete', id);
        this.$emit('panel-close');
        this.showAlert(this.$t('DELETE_CONTACT.API.SUCCESS_MESSAGE'));
        if (
          this.$route.name !== 'contacts_dashboard' &&
          !this.pipelineContact
        ) {
          this.$router.push({ name: 'contacts_dashboard' });
        }
        this.$emit('contact-deleted');
      } catch (error) {
        this.showAlert(
          error.message
            ? error.message
            : this.$t('DELETE_CONTACT.API.ERROR_MESSAGE')
        );
      }
    },
    openMergeModal() {
      this.toggleMergeModal();
    },
    pad(value) {
      return value < 10 ? '0' + value : value;
    },
    openRemainderModal() {
      // if(!this.$route.params.conversation_id){
      //   if(!this.reminderFlag){
      //   this.showAlert("Please enable feature from super-admin");
      //   return
      //   }
      // }

      this.showRemainderModal = true;
    },
    openRemainderFollowUPModal() {
      this.showRemainderFollowupModal = true;
    },
    successMessageData({
      message,
      conversationId,
      formattedDate,
      formattedTime,
      demo_time,
    }) {
      if (message) {
        this.conversationId = conversationId;
        this.updatedDate = formattedDate;
        this.updatedTime = formattedTime;
        this.demo_time = demo_time;
        // this.getConversationData();
        this.showAlert(this.$t('DELETE_CONTACT.API.DEMO_MESSAGE'));
        this.formattedChatDateTime;
      }
    },
    async getConversationData() {
      const contactId = this.currentChat.meta?.sender?.id;
      let response = null;
      if (contactId) {
        try {
          response = await this.$store.dispatch(
            'contacts/getConversationData',
            contactId
          );
        } catch (error) {
          console.error('Error fetching conversation data:', error);
        }
      }
      this.demo_time = response?.demo_time || null;
    },
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    async fetchAgents() {
      try {
        const response = await axios.get(
          `${this.baseUrl}/api/v1/accounts/${this.accountId}/agents`,
          {
            headers: {
              'Content-Type': 'application/json',
              'api-access-token': this.$store.getters.getCurrentUser
                .access_token,
            },
          }
        );
        this.agentsList = response.data;
        this.syncAssignedAgentFromContact();
      } catch (error) {
        console.error('Error fetching agents:', error);
      }
    },
    syncAssignedAgentFromContact() {
      const { contact } = this;
      if (!contact?.id) {
        this.assignedAgent = null;
        return;
      }

      const assigneeId =
        contact.assignee_id != null && contact.assignee_id !== ''
          ? contact.assignee_id
          : contact.assignee?.id;

      if (assigneeId == null || assigneeId === '') {
        this.assignedAgent = null;
        return;
      }

      const fromList = this.agentsList.find(agent =>
        this.idsMatch(agent.id, assigneeId)
      );
      if (fromList) {
        this.assignedAgent = fromList;
        return;
      }

      if (
        contact.assignee?.id &&
        this.idsMatch(contact.assignee.id, assigneeId)
      ) {
        this.assignedAgent = contact.assignee;
        return;
      }

      this.assignedAgent = {
        id: assigneeId,
        name: contact.assignee_name,
      };
    },
    applyAssignedAgentToContactState(contactId, agent) {
      if (!contactId || !agent?.id) {
        return;
      }
      this.$store.dispatch('contacts/updateContact', {
        id: contactId,
        assignee_id: agent.id,
        assignee_name: agent.name,
        assignee: agent,
      });
    },
    onClickAssignAgent(selectedAgent) {
      if (selectedAgent) {
        const agentId = selectedAgent.id;
        const contactId = this.contact.id;
        if (contactId && agentId) {
          axios
            .post(
              `${this.baseUrl}/api/v1/accounts/${this.accountId}/contacts/${contactId}/assignments`,
              {
                agent_id: agentId,
              },
              {
                headers: {
                  'api-access-token': this.current_userId.access_token,
                },
              }
            )
            .then(response => {
              const agent = response?.data?.id
                ? { ...selectedAgent, ...response.data }
                : selectedAgent;
              this.showAlert('Agent successfully assigned', { success: true });
              this.applyAssignedAgentToContactState(contactId, agent);
              this.assignedAgent = agent;
              bus.$emit('on-assign-agent', { contactId, agent });
            })
            .catch(error => {
              console.error('Error assigning agent:', error);
            });
        } else {
          console.error('Missing contact ID or agent ID');
        }
      }
    },
    findAssignedAgent() {
      // Logic to find and return the currently assigned agent, if applicable
      return (
        this.agentsList.find(
          agent => agent.id === this.currentChat?.assignee_id
        ) || null
      );
    },

    getStates() {
      this.$store.dispatch('pipelines/getState');
    },

    idsMatch(firstId, secondId) {
      if (
        firstId === undefined ||
        firstId === null ||
        secondId === undefined ||
        secondId === null
      ) {
        return false;
      }
      return Number(firstId) === Number(secondId);
    },

    scheduleCrmSync() {
      if (this.isModalView && this.contact?.id) {
        this.contactModalHydrating = true;
      }
      if (this._crmSyncTimer) {
        clearTimeout(this._crmSyncTimer);
      }
      this._crmSyncTimer = setTimeout(() => {
        this._crmSyncTimer = null;
        this.syncCrmSelections();
      }, 0);
    },

    tryFinishContactModalHydrating() {
      if (!this.isModalView || !this.contactModalHydrating) {
        return;
      }
      if (this.uiFlags?.isFetchingItem || this.loadingSelection) {
        return;
      }
      if (this._crmSyncTimer) {
        return;
      }
      this.contactModalHydrating = false;
    },

    isCrmSyncCurrent(generation, contactId) {
      return (
        generation === this._crmSyncGeneration && contactId === this.contact?.id
      );
    },

    async syncCrmSelections() {
      if (this.isTransfering) {
        this.tryFinishContactModalHydrating();
        return;
      }

      const contactId = this.contact?.id;
      if (!contactId) {
        this.selectedBoard = null;
        this.selectedStatus = null;
        this.selectedState = null;
        this.stateList = [];
        this._pipelineStatusBoardId = null;
        this.tryFinishContactModalHydrating();
        return;
      }

      this._crmSyncGeneration = (this._crmSyncGeneration || 0) + 1;
      const generation = this._crmSyncGeneration;

      try {
        const resolvedBoardId = this.resolvedBoardId();

        if (!resolvedBoardId) {
          if (!this.isCrmSyncCurrent(generation, contactId)) return;
          this.selectedBoard = null;
          this.selectedStatus = null;
          this.stateList = [];
          this._pipelineStatusBoardId = null;
          await this.syncContactStateSelection(generation, contactId);
          return;
        }

        const board =
          this.boards.find(item => this.idsMatch(item.id, resolvedBoardId)) ||
          (this.selectedBoard &&
          this.idsMatch(this.selectedBoard.id, resolvedBoardId)
            ? this.selectedBoard
            : null);
        if (!board) {
          await this.syncContactStateSelection(generation, contactId);
          return;
        }

        this.selectedBoard = board;
        await this.syncPipelineStatusSelection(board, generation, contactId);
        await this.syncContactStateSelection(generation, contactId);
      } finally {
        if (this.isCrmSyncCurrent(generation, contactId)) {
          this.tryFinishContactModalHydrating();
        }
      }
    },

    applySelectedStatusFromList() {
      const resolvedStatusId = this.resolvedStatusId();
      if (!resolvedStatusId) {
        this.selectedStatus = null;
        return;
      }

      let foundStatus = this.stateList.find(status =>
        this.idsMatch(status.id, resolvedStatusId)
      );
      if (!foundStatus && this.stateList.length > 0) {
        foundStatus = this.stateList[0];
      }
      this.selectedStatus = foundStatus || null;
    },

    hasPipelineStatusesForBoard(boardId) {
      return this.idsMatch(this._pipelineStatusBoardId, boardId);
    },

    async syncPipelineStatusSelection(board, generation, contactId) {
      if (!board?.id) return;

      // Board selection already loaded pipelines via getStatus — skip duplicate fetch.
      if (this.hasPipelineStatusesForBoard(board.id)) {
        if (!this.isCrmSyncCurrent(generation, contactId)) return;
        this.applySelectedStatusFromList();
        return;
      }

      this.loadingSelection = true;
      try {
        const response = await this.$store.dispatch(
          'pipelines/getStatusFromBoard',
          { board_id: board.id }
        );
        if (!this.isCrmSyncCurrent(generation, contactId)) return;

        this.stateList = response?.data?.data || [];
        this._pipelineStatusBoardId = board.id;
        this.applySelectedStatusFromList();
      } finally {
        if (this.isCrmSyncCurrent(generation, contactId)) {
          this.loadingSelection = false;
        }
      }
    },

    async syncContactStateSelection(generation, contactId) {
      const resolvedStateId = this.contact?.state_id;
      if (!resolvedStateId) {
        // Keep a local first-time State pick while assignState is still in flight.
        if (
          this.isCrmSyncCurrent(generation, contactId) &&
          !this.selectedState?.id
        ) {
          this.selectedState = null;
        }
        return;
      }

      // Keep an in-modal state pick visible while assignState is still in flight.
      if (
        this.selectedState?.id &&
        !this.idsMatch(this.selectedState.id, resolvedStateId)
      ) {
        return;
      }

      let foundState = this.state.find(state =>
        this.idsMatch(state.id, resolvedStateId)
      );
      if (foundState) {
        if (this.isCrmSyncCurrent(generation, contactId)) {
          this.selectedState = foundState;
        }
        return;
      }

      try {
        const response = await this.$store.dispatch('contacts/getState', {
          id: resolvedStateId,
          contact_id: this.contact.id,
        });
        if (!this.isCrmSyncCurrent(generation, contactId)) return;
        if (!response?.data) return;

        foundState = this.state.find(state =>
          this.idsMatch(state.id, resolvedStateId)
        );
        this.selectedState =
          foundState ||
          (this.contact.state_name
            ? { id: resolvedStateId, name: this.contact.state_name }
            : { id: resolvedStateId });
      } catch (error) {
        console.error('Failed to fetch state data:', error);
      }
    },

    async assignContactState(stateId) {
      if (!this.contact?.id) {
        return;
      }
      const data = {
        stateId,
        contactId: this.contact.id,
      };
      try {
        const response = await this.$store.dispatch(
          'contacts/assignState',
          data
        );
        if (response.status === 200) {
          const matchedState =
            this.state.find(s => this.idsMatch(s.id, stateId)) ||
            this.states.find(s => this.idsMatch(s.id, stateId));
          this.selectedState = matchedState || { id: stateId };
          const updatePayload = {
            id: this.contact.id,
            state_id: stateId,
            state_name: matchedState?.name,
          };
          // Only refresh board/pipeline ids already known — never null them out.
          const boardId = this.resolvedBoardId();
          const statusId = this.resolvedStatusId();
          if (boardId != null) {
            updatePayload.board_id = boardId;
          }
          if (statusId != null) {
            updatePayload.status_id = statusId;
          }
          this.$store.dispatch('contacts/updateContact', updatePayload);
          bus.$emit('on-assign');
          this.showAlert('State updated successfully', { success: true });
        } else {
          this.selectedState = this.resolveStateSelectionFromContact();
        }
      } catch (error) {
        this.selectedState = this.resolveStateSelectionFromContact();
        this.showAlert('Failed to assign state', { success: false });
      }
    },

    resolveStateSelectionFromContact() {
      const stateId = this.contact?.state_id;
      if (!stateId) {
        return null;
      }
      return (
        this.state.find(state => this.idsMatch(state.id, stateId)) ||
        this.states.find(state => this.idsMatch(state.id, stateId)) ||
        (this.contact.state_name
          ? { id: stateId, name: this.contact.state_name }
          : { id: stateId })
      );
    },

    resolvedBoardId() {
      const boardId = this.contact?.board_id ?? this.selectedBoard?.id;
      return boardId === undefined || boardId === null || boardId === ''
        ? null
        : boardId;
    },

    resolvedStatusId() {
      const statusId = this.contact?.status_id ?? this.selectedStatus?.id;
      return statusId === undefined || statusId === null || statusId === ''
        ? null
        : statusId;
    },

    resolvedContactStateId() {
      const stateId = this.contact?.state_id ?? this.selectedState?.id;
      return stateId === undefined || stateId === null || stateId === ''
        ? null
        : stateId;
    },

    async moveItem() {
      this.isTransfering = true;
      try {
        console.log('from move item', this.selectedBoard);
        const preservedStateId = this.resolvedContactStateId();
        const data = {
          boardId: this.selectedBoard?.id,
          statusId: this.selectedStatus?.id,
          // Preserve CRM state on board/pipeline moves; state changes use assignContactState.
          stateId: preservedStateId,
          contactId: this.contact.id,
        };

        const response = await this.$store.dispatch(
          'pipelines/moveStatus',
          data
        );

        if (response?.data) {
          this.showAlert(response.data.message, {
            success: response.data.success,
          });
          this.selectedStatus = this.stateList.find(status =>
            this.idsMatch(status.id, response.data.data.status_id)
          );
          // Board/pipeline moves must not alter the CRM state shown in the modal.
          const contactData = response.data.data || {};
          const updatePayload = {
            id: this.contact.id,
            board_id: contactData.board_id,
            status_id: contactData.status_id,
          };
          if (preservedStateId != null) {
            updatePayload.state_id = preservedStateId;
          } else if (
            contactData.state_id !== undefined &&
            contactData.state_id !== null &&
            contactData.state_id !== ''
          ) {
            // Reflect an existing DB state (e.g. Overview rows omit state_id).
            updatePayload.state_id = contactData.state_id;
          }
          // Keep pipelines already loaded for this board so post-save sync does not refetch.
          if (this.selectedBoard?.id) {
            this._pipelineStatusBoardId = this.selectedBoard.id;
          }
          this.$store.dispatch('contacts/updateContact', updatePayload);
          bus.$emit('pipeline-contact-board-changed', {
            contactId: this.contact.id,
            boardId: contactData.board_id ?? null,
          });
          this.notifyPipelineBoardDataReload();
        }
      } catch (error) {
        console.error('❌ Error in moveItem:', error);
        this.showAlert('Failed to update contact. Please try again.');
      } finally {
        this.isTransfering = false;
        this.scheduleCrmSync();
      }
    },
    //  getStates() {
    //     this.$store.dispatch('pipelines/getState');
    //   },

    getBoards() {
      this.$store.dispatch('pipelines/getBoards');
    },
    // getStatus(data) {
    //   this.$store.dispatch('pipelines/getStatus',data);
    // },
    async onBoardChange() {
      this.selectedStatus = null;
      // Drop cached pipelines from the previous board before loading the new one.
      this._pipelineStatusBoardId = null;
      if (this.selectedBoard) {
        console.log('selected Board', this.selectedBoard);
        await this.getStatus(this.selectedBoard);
      } else {
        this.stateList = [];
      }
    },
    async getStatus(boardId) {
      console.log(boardId);
      this.loadingSelection = true;
      const data = {
        board_id: boardId?.id,
      };
      console.log('data========', data);
      try {
        const response = await this.$store.dispatch(
          'pipelines/getStatusFromBoard',
          data
        );
        this.stateList = response?.data?.data || [];
        // Only cache after a successful load for this board.
        this._pipelineStatusBoardId = boardId?.id ?? null;
        console.log('stateList', this.stateList);

        let foundStatus = this.stateList.find(status =>
          this.idsMatch(status.id, this.contact?.status_id)
        );

        if (!foundStatus && this.stateList.length > 0) {
          foundStatus = this.stateList[0];
        }

        this.selectedStatus = foundStatus || null;
        console.log('selectedStatus', this.selectedStatus);
        console.log('selectedStatus_name', this.selectedStatus?.name);
      } catch (error) {
        console.error('Failed to fetch pipelines for board:', error);
        this.stateList = [];
        this._pipelineStatusBoardId = null;
        this.selectedStatus = null;
      } finally {
        this.loadingSelection = false;
      }
    },
    selectBoard() {
      this.scheduleCrmSync();
    },
    async handleChange() {
      await this.onBoardChange();
      await this.moveItem();
    },
    isOptionDisabled(option) {
      console.log('option', option, option.id);
      console.log(
        'this.selectedBoard && option.id === this.selectedBoard.id;',
        this.selectedBoard && option.id === this.selectedBoard.id
      );
      return this.selectedBoard && option.id === this.selectedBoard.id;
    },
  },
};
</script>
<style lang="scss" scoped>
.contact-info-text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.edit-button-class {
  background-color: rgb(66, 191, 240);
}

.copy-profile-link-button-class {
  border: 1px solid #d1dbe8 !important;
  border-radius: 8px !important;
  background-color: #f8fafc !important;
  color: #40518a !important;
  box-shadow: none !important;

  &:hover,
  &:focus,
  &:active {
    background-color: #f8fafc !important;
    border-color: #d1dbe8 !important;
    color: #40518a !important;
    box-shadow: none !important;
  }

  :deep(.icon),
  :deep(.icon--blue) {
    color: #40518a !important;
  }

  :deep(svg) {
    display: block;
  }
}

.copy-profile-link-button-class--copied {
  :deep(.icon) {
    color: #22c55e !important;
  }
}

body.dark .copy-profile-link-button-class {
  background-color: rgb(30 41 59 / 0.95) !important;
  border-color: rgb(71 85 105 / 0.95) !important;
  color: #e2e8f0 !important;

  &:hover,
  &:focus,
  &:active {
    background-color: rgb(51 65 85 / 0.9) !important;
    border-color: rgb(100 116 139 / 0.95) !important;
    color: #f1f5f9 !important;
  }

  :deep(.icon),
  :deep(.icon--blue) {
    color: #e2e8f0 !important;
  }
}

body.dark .copy-profile-link-button-class--copied {
  :deep(.icon) {
    color: #4ade80 !important;
  }
}

.edit-button-class {
  border-radius: 8px !important;
}

.contact-modal-links {
  padding: 2px;
  background-color: rgb(248, 248, 248);
  /* Change background color */
}
.contact-modal-selected {
  background: linear-gradient(180deg, #dceaf8 0%, #d0e2f5 100%);
  border: 1px solid #9ec0e8;
}

body.dark .contact-modal-selected {
  background: linear-gradient(
    180deg,
    rgb(30 58 95 / 0.72) 0%,
    rgb(30 41 59 / 0.62) 100%
  ) !important;
  border-color: rgb(59 130 246 / 0.45) !important;
}

body.dark .contact-modal-links {
  padding: 1px !important;
  background-color: rgb(214, 218, 240) !important ;
}

.icon-text {
  font-size: 2px;
  color: blue;
  background-color: #e2e8f0;
}

.relative-position {
  display: flex;
  justify-content: end;
}

.dialpadModal.modal-mask {
  justify-content: center !important;
  background-color: rgba(0, 0, 0, 0.9);
  margin-top: 0px;
}

.reminder_icon {
  background-color: hsl(209 13.3% 95.3% / 1) !important;
  color: black !important;
}

body.dark .reminder_icon {
  background-color: hsl(207 5.6% 31.6% / 1) !important;
  color: white !important;
}

.dialpadModal >>> .modal-container {
  margin-top: 250px;
}

.options-container {
  display: flex;
  flex-direction: column;
  /* Stack buttons vertically */
  gap: 6px;
  position: absolute;
  /* Position absolutely relative to the button's container */
  top: 100%;
  right: 0;
  width: 98%;
  z-index: 1000;
  background-color: white;
  padding-top: 6px;
  margin-top: 1px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  height: 172px;
  overflow: scroll;
}

.lightgrey {
  color: #aaaaaa;
}

.blue-color {
  color: #40518a;
}

.options-container::-webkit-scrollbar {
  display: none;
}

/* CHANGES  */

/* Remove margin for the last button */
.custom-button:last-child {
  margin-right: 0;
}

.custom-button {
  background-color: transparent !important;
  /* Remove background color */
  color: #aaaaaa;
  /* margin-right: 10px; */
}

.custom-button .icon {
  color: #aaaaaa;
  /* Set icon color to grey */
  font-size: 20px;
  /* Adjust icon size, increase it as needed */
}

.more-vertical-icon .icon {
  font-weight: bold;
  /* Make "more-vertical" icon bold */
  color: #aaaaaa;
}

/* .absolute-button {
  position: absolute;
  right: 18px;
  top: 2px;
} */
.text-more {
  color: #4b5155;
}
.dark .text-more {
  color: #f1f5f9;
}

.display_none {
  display: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.move_to_board {
  background-color: #40518a;
  color: whitesmoke;
  padding: 8px;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

.board-selector-wrapper {
  position: relative;
  flex: 1;
  min-width: 0;
}

.board-selector {
  position: relative;

  .board-button {
    width: 100%;
    min-width: 0;
    padding: 0 8px;
    justify-content: stretch;

    :deep(.button__content) {
      width: 100%;
      min-width: 0;
    }

    &__inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      min-width: 0;
      gap: 0.375rem;
    }

    &__text {
      display: block;
      flex: 1;
      min-width: 0;
      min-height: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
    }

    &__chevron {
      flex-shrink: 0;
      color: #64748b;
    }
  }

  .assignAgentClass {
    background-color: red;
  }
}

.contact-summary-icon-cell {
  flex-shrink: 0;
}
.contact-summary-line {
  line-height: 1.4;
  word-break: normal;
  overflow-wrap: break-word;
}
.contact-summary-error-line {
  line-height: 1.4;
  color: var(--r-400, #e74c3c);
  word-break: normal;
  overflow-wrap: break-word;
}

.button.clear.secondary:focus:not(:hover) {
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}

.state-color-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  flex-shrink: 0;
}

.board-button__text--with-state {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
}

.contact-info-modal {
  padding: 1.25rem 1rem 1rem;

  &.contact-info-modal--contacts-modal,
  &.contact-info-modal--embedded-panel {
    /* Match ContactInfoPanel section / accordion margins (12px) */
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  &.contact-info-modal--contacts-modal,
  &.contact-info-modal--embedded-panel {
    padding-bottom: 1.25rem;
  }

  .contact-info-modal__loading-overlay {
    position: absolute;
    inset: 0;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    padding: 1.5rem;
    background: rgb(255 255 255 / 0.45);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    cursor: wait;
  }

  .contact-info-modal__loading-spinner {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    border: 3px solid #d6e6f8;
    border-top-color: #1b7edb;
    animation: contact-info-modal-loading-spin 0.7s linear infinite;
  }

  .contact-info-modal__loading-text {
    margin: 0;
    font-size: 0.875rem;
    font-weight: 600;
    color: #334155;
    text-align: center;
    letter-spacing: -0.01em;
    line-height: 1.35;
  }

  .contact-modal-title {
    font-weight: 600;
    letter-spacing: -0.01em;
  }

  /* Icon-only header controls: fixed square (14px icon + prior 10px padding rhythm) */
  :deep(.contact-modal-header__actions .button.small) {
    box-sizing: border-box !important;
    width: 32px !important;
    height: 32px !important;
    min-width: 32px !important;
    min-height: 32px !important;
    max-width: 32px !important;
    max-height: 32px !important;
    padding: 0 !important;
    margin: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    line-height: 0 !important;
    flex-shrink: 0;
  }

  :deep(.contact-modal-header__actions .button .icon) {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
    margin: 0;
  }

  :deep(.contact-modal-header__actions .button svg) {
    display: block;
  }

  :deep(.contact-modal-header-icon-button) {
    border: 1px solid #d1dbe8 !important;
    border-radius: 8px !important;
    background-color: #f8fafc !important;
    box-shadow: none !important;

    &:hover,
    &:focus,
    &:active {
      background-color: #f8fafc !important;
      border-color: #d1dbe8 !important;
      box-shadow: none !important;
    }
  }

  :deep(.contact-modal-header-icon-button--close:hover),
  :deep(.contact-modal-header-icon-button--close:focus) {
    background-color: #fef2f2 !important;
    border-color: #fecaca !important;
  }

  .contact-modal-header__link {
    display: inline-flex;
    line-height: 0;
    flex-shrink: 0;
  }

  .contact-modal-header,
  .contact-modal-header__actions {
    overflow: visible;
  }

  .contact-modal-call-dropdown {
    flex-shrink: 0;

    :deep(.call-via-menu) {
      z-index: 50;
    }
  }

  .contact-profile-card {
    background: linear-gradient(180deg, #edf4fc 0%, #e8f2fb 100%);
    border: none;
    border-radius: 10px;
    padding: 1rem 0.75rem !important;
    margin-bottom: 1.25rem;
  }

  .contact-details-grid {
    margin-bottom: 1.25rem;
  }

  .contact-details-grid .icon-text {
    width: 26px;
    height: 26px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background-color: #e8f0fa;
    color: #40518a;
    font-size: inherit;
    margin-top: 0 !important;
    padding: 0 !important;
  }

  .contact-info-text-ellipsis {
    color: #334155;
    font-size: 0.8125rem;
  }

  .contact-board-selectors {
    margin-bottom: 1rem;
    gap: 0.75rem;
  }

  .board-selector label {
    display: block;
    font-size: 11px;
    font-weight: 500;
    color: #64748b;
    margin-bottom: 4px;
    line-height: 1.2;
  }

  .board-selector .board-button {
    width: 100%;
    min-height: 32px !important;
    height: 32px !important;
    padding: 0 8px !important;
    border-radius: 6px !important;
    background: #eef5fd !important;
    border: 1px solid #cfe0f5 !important;
    box-shadow: none !important;
    color: #1e3a5f !important;
    font-size: 0.8125rem !important;
  }

  .board-selector .board-button :deep(.button__content) {
    min-height: 0;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .board-selector .board-button:hover {
    background: #e5f0fc !important;
    border-color: #b8d4f0 !important;
  }

  .contact-section-label,
  .contact-field-label {
    font-size: 11px;
    font-weight: 500;
    color: #64748b;
    margin-bottom: 8px;
    display: block;
    line-height: 1.2;
  }

  .contact-links-row {
    align-items: flex-start;
    margin-bottom: 1rem;
    gap: 2rem;
  }

  .contact-more-links,
  .contact-social-links {
    flex: 1 1 0;
    min-width: 0;
  }

  .contact-modal-links {
    border-radius: 8px !important;
    background-color: #eef2f8 !important;
    border: 1px solid #e2e8f0;
    min-width: 32px;
    min-height: 32px;
    transition:
      background-color 0.15s ease,
      border-color 0.15s ease,
      box-shadow 0.15s ease;
  }

  :deep(.button.contact-modal-links:hover:not(.disabled):not(:disabled)),
  :deep(.button.contact-modal-links:focus:not(.disabled):not(:disabled)) {
    background-color: #e2eaf6 !important;
    border-color: #c5d4e8 !important;
    box-shadow: 0 1px 3px rgb(15 23 42 / 0.06);
  }

  .contact-modal-selected {
    background: linear-gradient(180deg, #dceaf8 0%, #d0e2f5 100%) !important;
    border-color: #9ec0e8 !important;
  }

  :deep(.button.contact-modal-selected:hover:not(.disabled):not(:disabled)),
  :deep(.button.contact-modal-selected:focus:not(.disabled):not(:disabled)) {
    background: linear-gradient(180deg, #d0e2f5 0%, #c4daf0 100%) !important;
    border-color: #8fb5e3 !important;
    box-shadow: 0 1px 3px rgb(15 23 42 / 0.08);
  }

  :deep(.button.contact-modal-links.disabled:hover),
  :deep(.button.contact-modal-links:disabled:hover) {
    background-color: #eef2f8 !important;
    border-color: #e2e8f0 !important;
    box-shadow: none;
  }

  .contact-assigned-section {
    margin-top: 0.25rem;
    margin-bottom: 0.5rem;
  }

  /* Trigger only — do not style .dropdown-pane buttons (search list, dismiss). */
  :deep(.contact-assigned-dropdown > .button) {
    width: 100%;
    min-height: 42px;
    border-radius: 8px !important;
    background: #eef5fd !important;
    border: 1px solid #cfe0f5 !important;
    box-shadow: none !important;
  }

  :deep(.contact-assigned-dropdown > .button:hover) {
    background: #e5f0fc !important;
    border-color: #b8d4f0 !important;
  }

  :deep(.label-wrap .label--add) {
    background-color: #dbeafe !important;
    border-radius: 6px !important;
    color: #40518a !important;
    border: none !important;
  }
}

@keyframes contact-info-modal-loading-spin {
  to {
    transform: rotate(360deg);
  }
}

body.dark .contact-info-modal {
  .contact-info-modal__loading-overlay {
    background: rgb(15 23 42 / 0.55);
  }

  .contact-info-modal__loading-spinner {
    border-color: rgb(51 65 85 / 0.9);
    border-top-color: #60a5fa;
  }

  .contact-info-modal__loading-text {
    color: #e2e8f0;
  }

  .contact-profile-card {
    background: linear-gradient(
      180deg,
      rgb(30 41 59 / 0.55) 0%,
      rgb(30 41 59 / 0.35) 100%
    );
    border: none;
  }

  .contact-info-text-ellipsis {
    color: #cbd5e1;
  }

  .board-selector .board-button,
  :deep(.contact-assigned-dropdown > .button) {
    background: rgb(30 41 59 / 0.6) !important;
    border-color: rgb(51 65 85 / 0.9) !important;
    color: #e2e8f0 !important;
  }

  .contact-modal-links {
    background-color: rgb(51 65 85 / 0.5) !important;
    border-color: rgb(71 85 105 / 0.8);
  }

  :deep(.button.contact-modal-links:hover:not(.disabled):not(:disabled)),
  :deep(.button.contact-modal-links:focus:not(.disabled):not(:disabled)) {
    background-color: rgb(51 65 85 / 0.72) !important;
    border-color: rgb(100 116 139 / 0.95) !important;
    box-shadow: 0 1px 3px rgb(0 0 0 / 0.2);
  }

  .contact-modal-selected {
    background: linear-gradient(
      180deg,
      rgb(30 58 95 / 0.72) 0%,
      rgb(30 41 59 / 0.62) 100%
    ) !important;
    border-color: rgb(59 130 246 / 0.45) !important;
  }

  :deep(.button.contact-modal-selected:hover:not(.disabled):not(:disabled)),
  :deep(.button.contact-modal-selected:focus:not(.disabled):not(:disabled)) {
    background: linear-gradient(
      180deg,
      rgb(37 72 115 / 0.82) 0%,
      rgb(30 41 59 / 0.72) 100%
    ) !important;
    border-color: rgb(96 165 250 / 0.55) !important;
  }

  :deep(.contact-modal-header-icon-button) {
    background-color: rgb(30 41 59 / 0.95) !important;
    border-color: rgb(71 85 105 / 0.95) !important;
    color: #e2e8f0 !important;

    &:hover,
    &:focus,
    &:active {
      background-color: rgb(51 65 85 / 0.9) !important;
      border-color: rgb(100 116 139 / 0.95) !important;
      color: #f1f5f9 !important;
    }
  }

  :deep(.contact-modal-header-icon-button .icon),
  :deep(.contact-modal-header-icon-button .icon--blue),
  :deep(.contact-modal-header-icon-button svg) {
    color: #e2e8f0 !important;
  }

  :deep(.contact-modal-header-icon-button--close:hover),
  :deep(.contact-modal-header-icon-button--close:focus) {
    background-color: rgb(127 29 29 / 0.4) !important;
    border-color: rgb(248 113 113 / 0.55) !important;
  }

  :deep(.contact-modal-header-icon-button--close:hover .icon),
  :deep(.contact-modal-header-icon-button--close:hover svg),
  :deep(.contact-modal-header-icon-button--close:focus .icon),
  :deep(.contact-modal-header-icon-button--close:focus svg) {
    color: #fecaca !important;
  }
}
</style>
